lmApp
  .controller('GoogleDrmController', ['$scope', '$rootScope', '$timeout', 'DrmService', 'ToastService', 'ValidatorService',
    function ($scope, $rootScope, $timeout, DrmService, ToastService, ValidatorService) {
      $scope.loading = false;
      $scope.googleDrmData = {};
      $scope.validateErrors = {};
      $scope.selectedNode = {};

      var _validate = function (data) {
        var error = {
          licenseKey: []
        };

        if (!data.licenseKey[0]) error.licenseKey[0] = true;
        if (!data.licenseKey[1]) error.licenseKey[1] = true;
        if (!data.provider) error.provider = true;
        if (!data.owner) error.owner = true;

        $scope.validateErrors = error;
        return error;
      };

      $scope.getGoogleDrm = function () {

        $scope.loading = true;
        $rootScope.showLinearProgress('#googleDrmLoader');
        $timeout(function () {
          $scope.googleDrmData = DrmService.GetVerimatrix();

          $scope.loading = false;
          $rootScope.hideLinearProgress('#googleDrmLoader');
        }, 1000);
      };

      $scope.saveGoogleDrmSettings = function () {
        if ($scope.loading) return;

        if (!_.isEmpty(_validate($scope.googleDrmData))) return;

        DrmService.SaveVerimatrix($scope.googleDrmData);
        ToastService.Small({
          title: 'Verimatrix settings successfully saved',
          color: 'green',
          icon: 'security-network',
          blocked: true
        }, 1000 * 3);
      };

      $scope.getGoogleDrm();
    }
  ]);